$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
  createCustomToggle();
  customSearchBar();
  modifySignup();
  contentMarginTop();
});

// Style Feature Button
function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);
    lineupButtonsGrid($element);
  });
}

function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');
  // if icons length + buttons length is greater than containerSize then add class "column" to buttonContainer
  if (icons.width() + buttons.width() > containerSize - 20) {
    buttonContainer.addClass('column');
  }
  // remove icons if there 0 children
  if (!icons.children().length) {
    icons.remove();
  }
}

// Custom Searchbox
function customSearchBar() {
  const searchPlaceholder = 'Search site';
  const input = $('.header .searchBox input');
  const searchBoxInput = $('.searchBox .searchBoxInput');
  const searchBoxSubmit = $('.searchBox .searchBoxSubmit');

  input.val('').attr('placeholder', searchPlaceholder);
  searchBoxSubmit.insertBefore(searchBoxInput);
}

// Create Mobile Nav Toggle
function createCustomToggle() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<span class="toggle-line"></span>');
  });
}

// Customize Sign Up Widget
function modifySignup() {
  const signupWidget = $('.tier-four .emailSignup');

  signupWidget.each(function () {
    const $this = $(this);
    const inputField = $this.find('.emailInputField');
    const submitButton = $this.find('.emailInputSubmit');

    $this.find('.emailSignupText').replaceWith(`
      <div class="emailSignupTextContainer">       
        <h6>Be In the Know</h6>
        <p>Join the Fan Club!</p>     
      </div>`);

    $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');

    inputField
      .find('.inputFieldTextbox')
      .val('')
      .attr('placeholder', 'Enter Email Address')
      .attr('aria-label', 'Enter Email Address');

    submitButton.find('.emailSubmitButton').text('subscribe');
  });
}

// Calculate content margin top
function contentMarginTop() {
  function updateContentMargin() {
    const headerHeight = $('header')[0].getBoundingClientRect().height;
    const isHomepage = $('body').hasClass('homepage');
    const isMobile = window.innerWidth <= 1100;

    let marginTop = headerHeight;

    if (!isHomepage && !isMobile) {
      marginTop += 15;
    } else if (!isHomepage && isMobile) {
      marginTop += 50;
    }

    $('.content').css('margin-top', marginTop + 'px');
  }

  $(document).ready(updateContentMargin);
  $(globalThis).on('load scroll resize', updateContentMargin);
}
